(function () {
  "use strict";

  function initProgressiveStickyHeadings() {
    // Only run on About page (rich-text sections present)
    var isAbout =
      /\/pages\//.test(window.location.pathname) &&
      document.querySelector(".shopify-section--rich-text");
    if (!isAbout) return;

    // ---------- config ----------
    var ACTIVE_CLASS = "sticky-seq-active";
    var PINNED_CLASS = "sticky-seq-pinned";
    var PLACEHOLDER_CLASS = "sticky-seq-placeholder";

    var topOffset = function () {
      return 60; // viewport top anchor for active sticky (kept from your current code)
    };

    function cssNumber(varName, fallback, el) {
      var cs = getComputedStyle(el || document.documentElement);
      var v = cs.getPropertyValue(varName);
      var n = parseFloat(v);
      return isNaN(n) ? fallback : n;
    }

    function getGapPx(scopeEl) {
      var gapVh = cssNumber("--sticky-gap-vh", 20, scopeEl);
      return Math.round(window.innerHeight * (gapVh / 100));
    }
    function getBufferPx(scopeEl) {
      return Math.round(cssNumber("--sticky-buffer-px", 24, scopeEl));
    }
    function getTriggerLeadPx(scopeEl) {
      // Global/first-heading early trigger (px)
      return Math.round(cssNumber("--sticky-trigger-lead-px", 8, scopeEl));
    }
    function getNextTriggerLeadPx(scopeEl) {
      // NEW: earlier trigger for 2nd, 3rd, ... headings (falls back to the global lead)
      var globalLead = getTriggerLeadPx(scopeEl);
      var nextLead = cssNumber("--sticky-next-trigger-lead-px", NaN, scopeEl);
      return Math.round(isNaN(nextLead) ? globalLead : nextLead);
    }

    // ---------- sequence resolution ----------
    var config = (window.DSSLR_SETTINGS || {}).stickyHeadingSequence || [];
    if (!Array.isArray(config) || config.length === 0) return;

    var normalizeText = function (str) {
      return (str || "").replace(/\s+/g, " ").trim();
    };
    var headingSelectors = [
      ".shopify-section--rich-text .h1",
      ".shopify-section--rich-text .h2",
      ".shopify-section--rich-text .h3",
      ".shopify-section--rich-text .h4",
      ".shopify-section--rich-text .display-xl",
      ".shopify-section--rich-text .display-l",
      ".shopify-section--rich-text .display-m",
    ];
    var candidates = Array.from(
      document.querySelectorAll(headingSelectors.join(","))
    );

    var sequence = [];
    config.forEach(function (word) {
      var target = normalizeText(word);
      var el = candidates.find(function (c) {
        return normalizeText(c.textContent) === target;
      });
      if (el) {
        el.classList.add("sticky-seq-heading"); // keep margins neutral
        sequence.push({ word: target, el: el });
      }
    });
    if (sequence.length < 2) return;

    // Scope CSS var reads to the first heading so you can override per-section/page
    var scopeEl = sequence[0].el;

    // ---------- geometry helpers ----------
    function offsetParentDocTop(el) {
      var op = el.offsetParent || document.documentElement;
      var r = op.getBoundingClientRect();
      return r.top + window.scrollY;
    }
    function offsetParentDocLeft(el) {
      var op = el.offsetParent || document.documentElement;
      var r = op.getBoundingClientRect();
      return r.left + window.scrollX;
    }

    // ---------- state ----------
    var state = { activeIndex: -1, pinned: new Set() };

    // ---------- placeholders ----------
    function ensurePlaceholders() {
      sequence.forEach(function (item) {
        if (item.placeholder) return;
        var ph = document.createElement("div");
        ph.className = PLACEHOLDER_CLASS;
        ph.style.height = (item.height || 0) + "px";
        ph.style.display = "none";
        item.el.parentNode &&
          item.el.parentNode.insertBefore(ph, item.el.nextSibling);
        item.placeholder = ph;
      });
    }

    // ---------- role resets & measurement ----------
    function resetRolesToNormal() {
      sequence.forEach(function (item) {
        item.el.classList.remove(ACTIVE_CLASS);
        item.el.classList.remove(PINNED_CLASS);
        item.el.style.position = "";
        item.el.style.top = "";
        item.el.style.left = "";
        item.el.style.width = "";
        item.el.style.transform = "";
        item.el.style.zIndex = "";
      });
    }

    function measure() {
      sequence.forEach(function (item) {
        var rect = item.el.getBoundingClientRect();
        item.top = rect.top + window.scrollY; // doc Y
        item.vwTop = rect.top; // viewport Y (for seamless fix)
        item.vwLeft = rect.left; // viewport X (for fixed)
        item.docLeft = rect.left + window.scrollX; // doc X (for absolute)
        item.width = rect.width;
        item.height = rect.height || item.el.offsetHeight || 0;
        if (item.placeholder)
          item.placeholder.style.height = item.height + "px";
      });
    }

    function stagePlaceholders(activeIndex, pinnedSet) {
      var gapPx = getGapPx(scopeEl);
      var bufferPx = getBufferPx(scopeEl);
      sequence.forEach(function (item, idx) {
        var show = idx === activeIndex || (pinnedSet && pinnedSet.has(idx));
        if (!item.placeholder) return;
        if (show) {
          item.placeholder.style.display = "block";
          item.placeholder.style.marginBottom =
            pinnedSet && pinnedSet.has(idx) ? gapPx + bufferPx + "px" : "0px";
        } else {
          item.placeholder.style.display = "none";
          item.placeholder.style.marginBottom = "0px";
        }
      });
    }

    // ---------- role application (smooth, no jump) ----------
    function setRoleActive(idx) {
      var item = sequence[idx];
      var offset = topOffset();

      item.el.classList.add(ACTIVE_CLASS);
      item.el.classList.remove(PINNED_CLASS);
      item.el.style.position = "fixed";
      item.el.style.top = offset + "px";
      item.el.style.left = item.vwLeft + "px"; // keep same X
      item.el.style.width = item.width + "px"; // lock width to avoid reflow wobble
      item.el.style.transform = "none";
      item.el.style.zIndex = "2";
    }

    function setRolePinned(idx, constrainedTopDoc /* optional */) {
      var item = sequence[idx];
      var gapPx = getGapPx(scopeEl);
      var bufferPx = getBufferPx(scopeEl);

      var desiredDocTop;
      if (typeof constrainedTopDoc === "number") {
        desiredDocTop = constrainedTopDoc;
      } else {
        var next = sequence[idx + 1];
        desiredDocTop = next.top - item.height - gapPx - bufferPx;
      }

      var topInParent = desiredDocTop - offsetParentDocTop(item.el);
      var leftInParent = item.docLeft - offsetParentDocLeft(item.el);

      item.el.classList.add(PINNED_CLASS);
      item.el.classList.remove(ACTIVE_CLASS);
      item.el.style.position = "absolute";
      item.el.style.top = Math.max(topInParent, 0) + "px";
      item.el.style.left = leftInParent + "px";
      item.el.style.width = item.width + "px";
      item.el.style.transform = "none";
      item.el.style.zIndex = "1";
    }

    function clearRole(idx) {
      var item = sequence[idx];
      item.el.classList.remove(ACTIVE_CLASS);
      item.el.classList.remove(PINNED_CLASS);
      item.el.style.position = "";
      item.el.style.top = "";
      item.el.style.left = "";
      item.el.style.width = "";
      item.el.style.transform = "";
      item.el.style.zIndex = "";
    }

    // ---------- decision logic (with buffer + early trigger lead) ----------
    function decideState(scrollY) {
      var offset = topOffset();
      var gapPx = getGapPx(scopeEl);
      var bufferPx = getBufferPx(scopeEl);
      var leadPx = getTriggerLeadPx(scopeEl); // global / first heading lead
      var leadNextPx = getNextTriggerLeadPx(scopeEl); // NEW: subsequent headings lead

      var mainEl = document.querySelector("#main, main");
      var mainBounds = mainEl ? mainEl.getBoundingClientRect() : null;
      var mainBottom = mainBounds
        ? mainBounds.bottom + window.scrollY
        : Infinity;

      // Before first heading — allow early trigger by leadPx
      var firstStart = sequence[0].top - offset - leadPx;
      if (scrollY < firstStart)
        return { activeIndex: -1, pinnedSet: new Set(), constrained: {} };

      // Furthest heading that crossed the (early) sticky line (global lead)
      var furthest = -1;
      for (var i = 0; i < sequence.length; i++) {
        if (scrollY + leadPx >= sequence[i].top - offset) furthest = i;
        else break;
      }
      if (furthest < 0)
        return { activeIndex: -1, pinnedSet: new Set(), constrained: {} };

      var pinnedSet = new Set();
      var constrained = {};
      var isLast = furthest === sequence.length - 1;

      if (isLast) {
        if (sequence.length > 1) {
          var prevIdx = furthest - 1;
          var prev = sequence[prevIdx];
          var bufferedHandoverPrev =
            sequence[furthest].top - prev.height - gapPx - bufferPx;
          if (scrollY + leadNextPx >= bufferedHandoverPrev)
            pinnedSet.add(prevIdx);
        }
        var last = sequence[furthest];
        var lastBottomIfActive = scrollY + offset + last.height;
        if (lastBottomIfActive >= mainBottom) {
          pinnedSet.add(furthest);
          constrained[furthest] = Math.max(mainBottom - last.height, 0);
          return { activeIndex: -1, pinnedSet, constrained };
        } else {
          return { activeIndex: furthest, pinnedSet, constrained };
        }
      }

      var nextIdx = furthest + 1;
      var current = sequence[furthest];
      var next = sequence[nextIdx];

      var bufferedHandover = next.top - current.height - gapPx - bufferPx;

      // Use the larger lead for promoting NEXT to active earlier, to avoid the late start feel
      if (scrollY + leadNextPx >= next.top - offset) {
        pinnedSet.add(furthest);
        return { activeIndex: nextIdx, pinnedSet, constrained: {} };
      } else if (scrollY + leadNextPx >= bufferedHandover) {
        pinnedSet.add(furthest);
        return { activeIndex: -1, pinnedSet, constrained: {} };
      } else {
        return { activeIndex: furthest, pinnedSet, constrained: {} };
      }
    }

    // ---------- pipeline ----------
    function applyPipeline(scrollY) {
      resetRolesToNormal();
      measure();
      var decision = decideState(scrollY);

      stagePlaceholders(decision.activeIndex, decision.pinnedSet);
      measure();

      if (
        state.activeIndex >= 0 &&
        state.activeIndex !== decision.activeIndex
      ) {
        clearRole(state.activeIndex);
      }
      state.pinned.forEach(function (idx) {
        if (!decision.pinnedSet.has(idx)) clearRole(idx);
      });

      if (decision.activeIndex >= 0) setRoleActive(decision.activeIndex);

      decision.pinnedSet.forEach(function (idx) {
        var cTop =
          typeof decision.constrained[idx] === "number"
            ? decision.constrained[idx]
            : undefined;
        setRolePinned(idx, cTop);
      });

      state.activeIndex = decision.activeIndex;
      state.pinned = decision.pinnedSet;
    }

    // ---------- init & stabilization ----------
    ensurePlaceholders();

    var stabilizePass = 0;
    var lastSig = "";
    function sig() {
      return sequence
        .map(function (it) {
          return Math.round(it.top || 0) + "x" + Math.round(it.height || 0);
        })
        .join("|");
    }
    function stabilize() {
      applyPipeline(window.scrollY);
      var s = sig();
      if (s !== lastSig && stabilizePass < 6) {
        lastSig = s;
        stabilizePass++;
        requestAnimationFrame(stabilize);
      }
    }

    stabilize();
    window.addEventListener("load", function () {
      stabilizePass = 0;
      lastSig = "";
      stabilize();
    });
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) {
        stabilizePass = 0;
        lastSig = "";
        stabilize();
      }
    });

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          applyPipeline(window.scrollY);
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });

    var resizeRaf;
    window.addEventListener("resize", function () {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () {
        state = { activeIndex: -1, pinned: new Set() };
        stabilizePass = 0;
        lastSig = "";
        stabilize();
      });
    });

    var mo = new MutationObserver(function () {
      state = { activeIndex: -1, pinned: new Set() };
      stabilizePass = 0;
      lastSig = "";
      requestAnimationFrame(stabilize);
    });
    mo.observe(document.querySelector("#main") || document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initProgressiveStickyHeadings
    );
  } else {
    initProgressiveStickyHeadings();
  }
})();
